import Vue from 'vue'
import Router from 'vue-router'

import Login from './views/Login/index.vue'
import Slide01 from './views/Slide01/index.vue'
import Slide02 from './views/Slide02/index.vue'
import Slide03 from './views/Slide03/index.vue'
import Slide05 from './views/Slide05/index.vue'
import Slide06 from './views/Slide06/index.vue'
import Slide08 from './views/Slide08/index.vue'
import Slide09 from './views/Slide09/index.vue'
import Slide10 from './views/Slide10/index.vue'
import Slide11 from './views/Slide11/index.vue'
import Slide12 from './views/Slide12/index.vue'
import Contact from './views/Contact/index.vue'
import Slide13 from './views/Slide13/index.vue'


Vue.use(Router)

const routes = [
    {
        path: '/login/:accessToken?',
        name: 'login',
        component: Login
    },

    {
        path: '/',
        name: 'slide-01',
        component: Slide01,
        meta: {
            title: 'Concept',
            isSlide: true,
            color: 'red',
            background: 'black',
            backgroundInvert: false
        }
    },
    {
        path: '/problem',
        name: 'slide-02',
        component: Slide02,
        meta: {
            title: 'Problem',
            isSlide: true,
            color: 'red',
            background: 'white',
            backgroundInvert: false
        }
    },
    {
        path: '/solution',
        name: 'slide-03',
        component: Slide03,
        meta: {
            title: 'Solution',
            isSlide: true,
            color: 'green',
            background: 'white',
            backgroundInvert: false
        }
    },
    {
        path: '/software',
        name: 'slide-05',
        component: Slide05,
        meta: {
            title: 'Software',
            isSlide: true,
            color: 'blue',
            background: 'white',
            backgroundInvert: false
        }
    },
    {
        path: '/value-proposition',
        name: 'slide-06',
        component: Slide06,
        meta: {
            title: 'Value proposition',
            isSlide: true,
            color: 'blue',
            background: 'black',
            backgroundInvert: 960
        }
    },
    {
        path: '/progress',
        name: 'slide-08',
        component: Slide08,
        meta: {
            title: 'Progress',
            isSlide: true,
            color: 'blue',
            background: 'white',
            backgroundInvert: false
        }
    },
    {
        path: '/market',
        name: 'slide-09',
        component: Slide09,
        meta: {
            title: 'Market',
            isSlide: true,
            color: 'pink',
            background: 'white',
            backgroundInvert: false
        }
    },
    {
        path: '/competition',
        name: 'slide-10',
        component: Slide10,
        meta: {
            title: 'Competition',
            isSlide: true,
            color: 'blue',
            background: 'white',
            backgroundInvert: false
        }
    },
    {
        path: '/war-chest',
        name: 'slide-11',
        component: Slide11,
        meta: {
            title: 'War Chest',
            isSlide: true,
            color: 'blue',
            background: 'white',
            backgroundInvert: false
        }
    },
    {
        path: '/team',
        name: 'slide-12',
        component: Slide12,
        meta: {
            title: 'Team',
            isSlide: true,
            color: 'blue',
            background: 'white',
            backgroundInvert: false
        }
    },
    {
        path: '/contact',
        name: 'contact',
        component: Contact,
        meta: {
            title: 'Contact',
            isSlide: true,
            color: 'blue',
            background: 'black',
            backgroundInvert: false
        }
    },
    {
        path: '/financial',
        name: 'slide-13',
        component: Slide13,
        meta: {
            title: 'Financial',
            isSlide: true,
            color: 'blue',
            background: 'white',
            backgroundInvert: false
        }
    },
    {
        path: '*',
        redirect: '/login'
    }
]

export default new Router({
    routes,
    mode: 'history',
    base: process.env.BASE_URL
})

export { routes }
